module.exports = __webpack_public_path__ + "images/emoji/arrow_double_up.afb6684cb51040e377e1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrow_double_up.png
// module id = ruBm
// module chunks = 2